import {Container, Typography} from "@material-ui/core";
import {FC} from "react";
import AirfieldUpsertForm from "../../components/airfield/AirfieldUpsertForm";
import {useTranslation} from "react-i18next";
import PermissionsGuard from "../../components/PermissionGuard";

interface UpsertAirfieldProps {
  isAdd: boolean
}

const UpsertAirfield: FC<UpsertAirfieldProps> = ({ isAdd }) => {
  const { t } = useTranslation();

  return (
    <PermissionsGuard
      allowedRoles={['SYSTEMADMIN', 'ADMINISTRATOR']}
      environment={'UpsertAirfield'}
      needTenant={true}
    >
      <Container maxWidth={false}>
        <Typography
          color="textPrimary"
          variant="h5"
          sx={{ mb: 5 }}
        >
          {isAdd ? t('ADD_AIRFIELD') : t('UPDATE_AIRFIELD')}
        </Typography>

        <AirfieldUpsertForm isAdd={isAdd} />
      </Container>
    </PermissionsGuard>
  );
}

export default UpsertAirfield;
